import type { UserRepository } from '#/domain/user/UserRepository'

export class AssignRolesUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string, roles: string[], organizationId?: string): Promise<void> {
    return this.repository.assignRoles(userId, roles, organizationId)
  }
}
